const PHG_LOGO = "/images/phg-logo.png";
const CDBJJ_LOGO = "/images/carpe2.png";

export default function LPFooter() {
  return (
    <footer className="w-full bg-[#0d0d0d] border-t border-white/5">

      {/* Top section */}
      <div className="w-full px-8 md:px-16 py-16">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-12">

          {/* Brand block — PHG上・大きく、CDBJJ下・小さめ */}
          <div className="flex flex-col gap-5">
            {/* PHG */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center">
                <img src={PHG_LOGO} alt="Powerhouse Gym" className="w-full h-full object-contain" />
              </div>
              <span
                className="text-white font-black uppercase leading-tight"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "22px", letterSpacing: "0.08em" }}
              >
                POWERHOUSE GYM
              </span>
            </div>

            {/* 区切り */}
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-white/15" />
              <span className="text-white/25 text-sm" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.3em" }}>×</span>
              <div className="w-8 h-px bg-white/15" />
            </div>

            {/* CDBJJ */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center">
                <img src={CDBJJ_LOGO} alt="Carpe Diem BJJ" className="w-full h-full object-contain brightness-0 invert" />
              </div>
              <span
                className="text-white font-black uppercase leading-tight"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "22px", letterSpacing: "0.08em" }}
              >
                CARPE DIEM BJJ
              </span>
            </div>

            <div className="w-10 h-px bg-red-600 mt-2" />
            <p
              className="text-white font-black uppercase leading-none"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(22px, 3vw, 36px)", letterSpacing: "0.04em" }}
            >
              LIVE THE<br />
              <span className="text-red-600">DISCIPLINE</span>
            </p>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              鍛える現実から目を逸らさない。<br />
              自分を整えるための、4つの装備。
            </p>
          </div>

          {/* Nav links */}
          <div className="flex flex-col gap-3">
            <p className="text-white/50 text-xs tracking-[0.4em] uppercase mb-2">Collection</p>
            {[
              { label: "Rash.G L/S", href: "#product-rush-ls" },
              { label: "Rash.G H/S", href: "#product-rush-ss" },
              { label: "Fight Shorts", href: "#product-fight-shorts" },
              { label: "Wide Tee", href: "#product-tee" },
            ].map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="text-white/60 text-sm tracking-widest uppercase hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </div>

          {/* Info */}
          <div className="flex flex-col gap-3">
            <p className="text-white/50 text-xs tracking-[0.4em] uppercase mb-2">Info</p>
            <div className="flex flex-col gap-2.5">
              <div className="flex items-center gap-2">
                <div className="w-1 h-1 bg-red-600 rounded-full flex-shrink-0" />
                <span className="text-white/60 text-sm">4 Items</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1 h-1 bg-white/30 rounded-full flex-shrink-0" />
                <span className="text-white/60 text-sm">BLACK / GRAY</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1 h-1 bg-white/30 rounded-full flex-shrink-0" />
                <span className="text-white/60 text-sm">Active Collection 2026</span>
              </div>
            </div>
          </div>

          {/* Collab logos — PHG上・CDBJJ下 */}
          <div className="flex flex-col items-start gap-4">
            <p className="text-white/50 text-xs tracking-[0.4em] uppercase">Collaboration</p>
            <div className="flex flex-col gap-4">
              <a
                href="https://powerhousegym.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 border border-white/10 px-4 py-3 hover:border-white/30 transition-colors cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center flex-shrink-0">
                  <img src={PHG_LOGO} alt="Powerhouse Gym" className="w-full h-full object-contain" />
                </div>
                <div>
                  <p className="text-white text-sm font-bold tracking-wider">POWERHOUSE GYM</p>
                  <p className="text-white/45 text-xs tracking-wide">Fitness Center</p>
                </div>
              </a>
              <div
                className="flex items-center gap-3 border border-white/5 px-4 py-3 opacity-50 cursor-default"
              >
                <div className="w-14 h-14 flex items-center justify-center flex-shrink-0">
                  <img src={CDBJJ_LOGO} alt="Carpe Diem BJJ" className="w-full h-full object-contain brightness-0 invert" />
                </div>
                <div>
                  <p className="text-white text-sm font-bold tracking-wider">CARPE DIEM BJJ</p>
                  <p className="text-white/45 text-xs tracking-wide">Brazilian Jiu-Jitsu</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="w-full border-t border-white/5 px-8 md:px-16 py-5">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-white/30 text-sm">
            © 2026 Powerhouse Gym × Carpe Diem BJJ. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-1.5 h-1.5 bg-red-600 rounded-full animate-pulse" />
            <span className="text-white/30 text-sm tracking-widest uppercase">Limited Collection</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
